import { render, staticRenderFns } from "./ziHuoDongList2.vue?vue&type=template&id=ed8cdece&scoped=true&"
import script from "./ziHuoDongList2.vue?vue&type=script&lang=js&"
export * from "./ziHuoDongList2.vue?vue&type=script&lang=js&"
import style0 from "./ziHuoDongList2.vue?vue&type=style&index=0&id=ed8cdece&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed8cdece",
  null
  
)

export default component.exports